import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { LMModel } from '@form/model';

@Component({
  selector:    'lm-text',
  standalone: false,
  templateUrl: './lm-text.component.html',
  styleUrls:   [ 'lm-text.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMTextComponent  {
  @Input() layoutObject: LMFormLayoutField | undefined;
  @Input() specFields: LMSpecFields | undefined;
  @Input() model: LMModel | undefined;
  @Input() mutexSpecField: LMSpecField | undefined;
  @Input() placeHolder: any;
  @Input() layoutInfo: LMFormLayoutInfo | undefined;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo | undefined;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo | undefined;
  @Input() parentCompoundFieldDisplayOnly = false;

  @HostBinding('class.wc-wrapper') useWC = false;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();
  @Output() errorOnMemberField: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
    // this.useWC = this.lmContextService.useWebComponents();
  }

  onFieldEvent($event: LMFieldEvent) {
    this.fieldEvent.emit($event);
  }

  onErrorMemberField(message: string) {
    this.errorOnMemberField.emit(message);
  }

}
